import React, { useState } from "react";
import { Box, Typography, Grid, CircularProgress, Divider, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { Formik, Form, FieldArray } from 'formik';
import * as Yup from 'yup';
import CustomButton from "../../common/CustomButton";
import CustomTextField from "../../common/CustomTextField";
import CustomTextarea from "../../common/CustomTextarea";
import { genericPost } from '../../../services/authServices';
import { CREATE_RECEIPT_VOUCHER_EXPORT } from '../../../services/apiRoutes';
import CustomAutocomplete from "../../common/CustomAutoComplete";
import CustomStyle from "../../common/CustomStyle";
import CustomPrefixSuffixField from "../../common/CustomPrefixSuffixField";
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { ClearRounded, SaveRounded, AddRounded, DeleteRounded } from "@mui/icons-material";
import { t } from "../../../constants/translationHelper";




const CreateReceiptVoucher = ({ handleClose, setMessage, userId, companyId, fetchData, fetchButtonList, commercialInvoiceList, shipmentOrgId, proformaInvoiceList, currencyId, currencySymbol, baseCurrencyId, baseCurrencySymbol, currencyList, receiptType, customerName, customerList, commanShipmentId, newShippingId, shipmentId }) => {

    const ValidationSchema = Yup.object().shape({
        date: Yup.string().required('Date is required'),
        receiptVoucherNo: Yup.string().required('Receipt Voucher No is required'),
        amount: Yup.number().required('Amount is required'),
        currencyId: Yup.number().required('Currency is required'),
        bankCharges: Yup.number().required('Bank Charges are required'),
        baseCurrencyId: Yup.number().required('Base Currency is required'),
        conversionRate: Yup.number().required('Conversion Rate is required'),
        baseAmount: Yup.number().required('Base Amount is required'),

        particulars: Yup.array()
            .of(
                Yup.object().shape({
                    importReferenceCiNo: Yup.string().required("CI is required"),
                    referenceAmount: Yup.number().required("amount is required"),
                    importPiNo: Yup.string().required("PI is required"),
                    receiptTypeId: Yup.string().required("receipt Type is required"),
                    amountInBaseCurrency: Yup.number().required("amount In Base is required"),
                    conversionRate: Yup.number().required("conversion Rate is required"),
                })
            )
            .required("Particulars are required"),
    });

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const updatedParticulars = values.particulars.map(particular => ({
                ...particular,
                date: values.date,
                bankCharges: values.bankCharges,

            }));
            const payload = {
                shipmentOrgId: values.shipmentOrgId,
                commanShipmentId: values.commanShipmentId,
                shipmentId: values.shipmentId,
                customerName: values.customerName,
                date: values.date,
                receiptVoucherNo: values.receiptVoucherNo,
                amount: values.amount,
                currencyId: values.currencyId,
                bankCharges: values.bankCharges,
                baseCurrencyId: values.baseCurrencyId,
                conversionRate: values.conversionRate,
                baseAmount: values.baseAmount,
                note: values.note,
                reference: values.reference,
                particulars: updatedParticulars,
            };

            const response = await genericPost(CREATE_RECEIPT_VOUCHER_EXPORT, payload);

            if (response.status === 201) {
                setMessage({
                    open: true,
                    text: response?.data?.message || "Receipt Voucher added successfully",
                    type: "success",
                });
                setTimeout(() => {
                    fetchData();
                    fetchButtonList();
                    handleClose();
                }, 1000);
            } else if (response.status === 409) {
                setMessage({
                    open: true,
                    text: response.message || 'already exists',
                    type: 'error',
                });
            } else {
                alert('Something went wrong');
            }
        } catch (error) {
            alert('Something went wrong');
        } finally {
            setSubmitting(false);
        }
    };

    const [formData] = useState({
        commanShipmentId: commanShipmentId,
        shipmentOrgId: shipmentOrgId,
        shipmentId: shipmentId,
        customerName: customerName || '',
        baseCurrencyId: baseCurrencyId || '',
        receiptVoucherNo: newShippingId,
        currencyId: currencyId || '',
        date: '',
        amount: '',
        bankCharges: '',
        conversionRate: '',
        baseAmount: '',
        note: '',
        reference: '',
        particulars: [
            {
                shipmentOrgId: shipmentOrgId,
                commanShipmentId: commanShipmentId,
                receiptVoucherNo: newShippingId,
                currencyId: currencyId,
                baseCurrencyId: baseCurrencyId,
                userId: userId,
                companyId: companyId,
                date: "",
                bankCharges: "",
                importReferenceCiNo: "",
                referenceAmount: "",
                importPiNo: "",
                exportPiNo: "",
                receiptTypeId: "1", // 1 for advance receipt 
                amountInBaseCurrency: "",
                conversionRate: "",
            },
        ],
    });

    return (
        <Box sx={{ mx: 'auto', mt: 0 }}>
            <Formik
                initialValues={formData}
                validationSchema={ValidationSchema}
                onSubmit={handleSubmit}
            >
                {({ isSubmitting, errors, touched, handleChange, setFieldValue, values }) => (
                    <Form>
                        <Grid container spacing={1} style={CustomStyle.container}>
                            <Grid item xs={4} md={4}>
                                <Typography sx={{ fontWeight: 600 }} style={CustomStyle.title}>
                                    {t("Create Receipt Voucher")}
                                </Typography>
                            </Grid>
                            <Grid item xs={8} md={8} style={CustomStyle.buttonContainer}>
                                <Box style={CustomStyle.buttonBox}>
                                    <CustomButton
                                        startIcon={<SaveRounded />}
                                        title={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save"}
                                        size="small"
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting}
                                    />
                                    <CustomButton
                                        startIcon={<SaveRounded />}
                                        title={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save and new"}
                                        size="small"
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting}
                                    />
                                    <CustomButton
                                        startIcon={<ClearRounded />}
                                        title="Cancel"
                                        size="small"
                                        variant="contained"
                                        onClick={handleClose}
                                    />
                                </Box>
                            </Grid>
                        </Grid>


                        <Divider />
                        <Grid container spacing={1} style={{ paddingLeft: "5%", paddingRight: "5%", paddingTop: "5px" }}>

                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                <CustomTextField
                                    type="date"
                                    name="date"
                                    fieldLabel="Date"
                                    value={values.date}
                                    required={true}
                                    onChange={handleChange}
                                    placeholder="mm/dd/yyyy"
                                    error={touched.date && !!errors.date}
                                    helperText={touched.date && errors.date}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}></Grid>


                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                <CustomTextField
                                    name="receiptVoucherNo"
                                    fieldLabel="Receipt Voucher No."
                                    value={values.receiptVoucherNo}
                                    required={true}
                                    onChange={handleChange}
                                    placeholder="Enter Receipt Voucher No."
                                    sx={CustomStyle.readOnly}
                                    readOnly={true}
                                    error={touched.receiptVoucherNo && !!errors.receiptVoucherNo}
                                    helperText={touched.receiptVoucherNo && errors.receiptVoucherNo}

                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                <CustomAutocomplete
                                    options={currencyList}
                                    placeholder="Select Currency"
                                    required={true}
                                    getOptionLabel={(option) => option.title}
                                    value={currencyList.find((option) => option.id === values.currencyId) || null}
                                    onChange={(e, newValue) =>
                                        setFieldValue('currencyId', newValue ? newValue.id : '')
                                    }
                                    fieldLabel="Currency"
                                    error={touched.currencyId && !!errors.currencyId}
                                    helperText={touched.currencyId && errors.currencyId}
                                    sx={CustomStyle.readOnly}
                                    readOnly={true}

                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}></Grid>

                            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                <CustomPrefixSuffixField
                                    prefix={currencySymbol}
                                    name="amount"
                                    fieldLabel="Amount"
                                    value={values.amount}
                                    required={true}
                                    type="number"
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFieldValue("amount", value);
                                        setFieldValue("baseAmount", value * values.conversionRate || 0);
                                    }}
                                    placeholder="Amount"
                                    error={touched.amount && !!errors.amount}
                                    helperText={touched.amount && errors.amount}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                <CustomAutocomplete
                                    options={currencyList}
                                    fieldLabel="Base Currency"
                                    required={true}
                                    getOptionLabel={(option) => option.title}
                                    value={currencyList.find((option) => option.id === values.baseCurrencyId) || null}
                                    onChange={(e, newValue) =>
                                        setFieldValue('baseCurrencyId', newValue ? newValue.id : '')
                                    }
                                    placeholder="Select Base Currency"
                                    error={touched.baseCurrencyId && !!errors.baseCurrencyId}
                                    helperText={touched.baseCurrencyId && errors.baseCurrencyId}
                                    sx={CustomStyle.readOnly}
                                    readOnly={true}

                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                <CustomPrefixSuffixField
                                    prefix={baseCurrencySymbol}
                                    tagLine="(In Base)"
                                    name="conversionRate"
                                    fieldLabel="Conversion Rate"
                                    value={values.conversionRate}
                                    required={true}
                                    type="number"
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFieldValue("conversionRate", value);
                                        setFieldValue("baseAmount", values.amount * value || 0);
                                    }}
                                    placeholder="Conversion Rate"
                                    error={touched.conversionRate && !!errors.conversionRate}
                                    helperText={touched.conversionRate && errors.conversionRate}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                <CustomPrefixSuffixField
                                    prefix={baseCurrencySymbol}
                                    tagLine="(In Base Currency)"
                                    name="baseAmount"
                                    fieldLabel="Base Amount"
                                    value={values.baseAmount}
                                    required={true}
                                    type="number"
                                    onChange={handleChange}
                                    placeholder="Enter Base Amount"
                                    readOnly={true}
                                    sx={CustomStyle.readOnly}
                                    error={touched.baseAmount && !!errors.baseAmount}
                                    helperText={touched.baseAmount && errors.baseAmount}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                <CustomPrefixSuffixField
                                    prefix={baseCurrencySymbol}
                                    tagLine="(In Base Currency)"
                                    name="bankCharges"
                                    fieldLabel="Bank Charges"
                                    value={values.bankCharges}
                                    required={true}
                                    type="number"
                                    onChange={handleChange}
                                    placeholder="Enter Bank Charges"
                                    error={touched.bankCharges && !!errors.bankCharges}
                                    helperText={touched.bankCharges && errors.bankCharges}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CustomTextField
                                    placeholder="Enter Reference"
                                    name="reference"
                                    fieldLabel="reference"
                                    type="text"
                                    value={values.reference}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FieldArray
                                    name="particulars"
                                    render={arrayHelpers => (
                                        <>
                                            <Grid item xs={12}>
                                                <Grid item xs={12} md={6}>
                                                    <Box display="flex" flexDirection="row" alignItems="center">
                                                        <AssignmentLateOutlinedIcon />
                                                        <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px", marginLeft: "4px" }}>
                                                            {t("Particulars")}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Box style={{ overflowX: 'auto', overflowY: 'auto' }}>
                                                    <Table style={{ minWidth: '1200px', width: '100%' }}>
                                                        <TableHead>
                                                            <TableRow style={{ height: '40px', backgroundColor: "#e7f0f7" }}>
                                                                <TableCell style={{ ...styles.tablecell, width: "10px" }}  >{t("No.")}</TableCell>
                                                                <TableCell style={{ ...styles.tablecell }}  >{t("Proforma Invoice")}</TableCell>
                                                                <TableCell style={{ ...styles.tablecell }}  >{t("Commercial Invoice")}</TableCell>
                                                                <TableCell style={{ ...styles.tablecell }}  >{t("Amount")}</TableCell>
                                                                <TableCell style={{ ...styles.tablecell }}  >{t("Conversion Rate")}</TableCell>
                                                                <TableCell style={{ ...styles.tablecell }}  >{t("Base Amount")}</TableCell>
                                                                <TableCell style={{ ...styles.tablecell, width: "10px" }} rowSpan={2}>{t("Action")}</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>

                                                            {values.particulars.map((particular, index) => {
                                                                return (
                                                                    <TableRow key={index}>
                                                                        <TableCell style={styles.tablecell}>{index + 1}</TableCell>
                                                                        <TableCell style={{ ...styles.tablecell, width: "200px" }}>
                                                                            <CustomAutocomplete
                                                                                required={true}
                                                                                options={proformaInvoiceList}
                                                                                getOptionLabel={(option) => option.title}
                                                                                value={
                                                                                    proformaInvoiceList.find(
                                                                                        (option) => option.id === values.particulars[index].importPiNo
                                                                                    ) || null
                                                                                }
                                                                                onChange={(e, newValue) => {
                                                                                    setFieldValue(`particulars.${index}.importPiNo`, newValue ? newValue.id : '');
                                                                                }}
                                                                                placeholder="Proforma Invoice"
                                                                                error={touched.particulars?.[index]?.importPiNo && !!errors.particulars?.[index]?.importPiNo}
                                                                                helperText={touched.particulars?.[index]?.importPiNo && errors.particulars?.[index]?.importPiNo}
                                                                            />
                                                                        </TableCell>

                                                                        <TableCell style={{ ...styles.tablecell, width: "200px" }}>
                                                                            <CustomAutocomplete
                                                                                required={true}
                                                                                options={commercialInvoiceList}
                                                                                getOptionLabel={(option) => option.title}
                                                                                value={
                                                                                    commercialInvoiceList.find(
                                                                                        (option) => option.id === values.particulars[index].importReferenceCiNo
                                                                                    ) || null
                                                                                }
                                                                                onChange={(e, newValue) => {
                                                                                    setFieldValue(`particulars.${index}.importReferenceCiNo`, newValue ? newValue.id : '');
                                                                                }}

                                                                                placeholder="Reference CI No."
                                                                                error={touched.particulars?.[index]?.importReferenceCiNo && !!errors.particulars?.[index]?.importReferenceCiNo}
                                                                                helperText={touched.particulars?.[index]?.importReferenceCiNo && errors.particulars?.[index]?.importReferenceCiNo}
                                                                            />
                                                                        </TableCell>

                                                                        <TableCell style={styles.tablecell}>
                                                                            <CustomPrefixSuffixField
                                                                                prefix={currencySymbol}
                                                                                required={true}
                                                                                name={`particulars.${index}.referenceAmount`}
                                                                                type="number"
                                                                                value={particular.referenceAmount || ''}
                                                                                onChange={(e) => {
                                                                                    handleChange(e);
                                                                                    const refAmount = parseFloat(e.target.value) || 0;
                                                                                    const convRate = parseFloat(values.particulars[index].conversionRate) || 0;
                                                                                    setFieldValue(`particulars.${index}.amountInBaseCurrency`, refAmount * convRate);
                                                                                }}
                                                                                placeholder="Amount"
                                                                                error={touched.particulars?.[index]?.referenceAmount && !!errors.particulars?.[index]?.referenceAmount}
                                                                                helperText={touched.particulars?.[index]?.referenceAmount && errors.particulars?.[index]?.referenceAmount}
                                                                            />

                                                                        </TableCell>

                                                                        <TableCell style={styles.tablecell}>
                                                                            <CustomPrefixSuffixField
                                                                                prefix={baseCurrencySymbol}
                                                                                required={true}
                                                                                name={`particulars.${index}.conversionRate`}
                                                                                type="number"
                                                                                value={particular.conversionRate || ''}
                                                                                onChange={(e) => {
                                                                                    handleChange(e);
                                                                                    const convRate = parseFloat(e.target.value) || 0;
                                                                                    const refAmount = parseFloat(values.particulars[index].referenceAmount) || 0;
                                                                                    setFieldValue(`particulars.${index}.amountInBaseCurrency`, refAmount * convRate);
                                                                                }}
                                                                                placeholder="Conversion Rate"
                                                                                error={touched.particulars?.[index]?.conversionRate && !!errors.particulars?.[index]?.conversionRate}
                                                                                helperText={touched.particulars?.[index]?.conversionRate && errors.particulars?.[index]?.conversionRate}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell style={styles.tablecell}>
                                                                            <CustomPrefixSuffixField
                                                                                prefix={baseCurrencySymbol}
                                                                                required={true}
                                                                                name={`particulars.${index}.amountInBaseCurrency`}
                                                                                type="number"
                                                                                value={particular.amountInBaseCurrency || ''}
                                                                                onChange={handleChange}
                                                                                placeholder="Base Amount"
                                                                                error={touched.particulars?.[index]?.amountInBaseCurrency && !!errors.particulars?.[index]?.amountInBaseCurrency}
                                                                                helperText={touched.particulars?.[index]?.amountInBaseCurrency && errors.particulars?.[index]?.amountInBaseCurrency}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell style={styles.tablecell}>
                                                                            <DeleteOutlineOutlinedIcon
                                                                                onClick={() => arrayHelpers.remove(index)}
                                                                                style={{ fontSize: "20px" }} />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            })}
                                                        </TableBody>

                                                        <TableRow style={{ height: '40px' }}>
                                                            <TableCell style={styles.tablecell} colSpan={7}>
                                                                <div style={{ margin: "auto", textAlign: "center" }}>
                                                                    <CustomButton
                                                                        sx={Additemstyle}
                                                                        startIcon={<AddRounded />}
                                                                        title="Add Item"
                                                                        variant="contained"
                                                                        size="small"
                                                                        onClick={() => arrayHelpers.push({
                                                                            importReferenceCiNo: '',
                                                                            referenceAmount: '',
                                                                        })}
                                                                    />
                                                                </div>
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow style={{ height: '40px' }}>
                                                            <TableCell style={styles.tablecellfooter} colSpan={3}  > {t("Total")}</TableCell>
                                                            <TableCell style={styles.tablecellfooter}>
                                                                {currencySymbol}&nbsp;
                                                                {(
                                                                    values.particulars.reduce((total, particular) => {
                                                                        const referenceAmount = parseFloat(particular.referenceAmount) || 0;
                                                                        return total + referenceAmount;
                                                                    }, 0)
                                                                ).toFixed(2)}
                                                            </TableCell>

                                                            <TableCell style={styles.tablecellfooter} colSpan={3} >
                                                                {baseCurrencySymbol}&nbsp;
                                                                {(
                                                                    values.particulars.reduce((total, particular) => {
                                                                        const amountInBaseCurrency = parseFloat(particular.amountInBaseCurrency) || 0;
                                                                        return total + amountInBaseCurrency;
                                                                    }, 0)
                                                                ).toFixed(2)}
                                                            </TableCell>

                                                        </TableRow>

                                                    </Table>
                                                </Box>
                                            </Grid>
                                        </>
                                    )}
                                />
                            </Grid>

                            <Grid item xs={8}>
                                <CustomTextarea
                                    name="note"
                                    type="text"
                                    fieldLabel="Note"
                                    value={values.note}
                                    onChange={handleChange}
                                    placeholder="Write a Notes"
                                    sx={{
                                        height: "80px !important"
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </Box>
    );
};

export default CreateReceiptVoucher;


const styles = {
    table: {
        minWidth: 650,
    },
    textMuted: {
        color: '#6c757d',
    },

    labelCell: {
        width: '180px',
    },
    tableContainer: {
        marginBottom: '16px',
    },
    header: {
        marginBottom: '16px',
    },
    title: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    customTableRow: {
        height: '20px',
    },
    editButton: {
        textAlign: 'right',
    },
    showDetailsSpan: {
        padding: '8px',
        fontWeight: 600,
        fontSize: '16px',
        color: '#212529',
        cursor: 'pointer',
    },
    expandIcon: {
        color: '#212529',
    },
    boxheading: {
        width: 70,  // Width of the box
        height: 70, // Height of the box, making it square
        background: 'radial-gradient(circle, #007BFF 0, rgba(0, 134, 201, .5) 0, #007BFF 100%)', // Radial gradient background
        color: 'white', // Text color
        display: 'flex', // Center content horizontally
        alignItems: 'center', // Center content vertically
        justifyContent: 'center', // Center content horizontally
        borderRadius: 14, // Rounded corners
        boxShadow: 3, // Box shadow for depth
    },
    headingname: {
        paddingTop: '10px',
        fontWeight: '600',
        fontSize: '20px',
        color: '#212529',
    },
    avatarcircle: {
        backgroundColor: '#007BFF',
        width: '30px',
        height: '30px',
        fontSize: '15px',
    },
    cardtittile: {
        padding: '8px',
        paddingLeft: '35px',
        fontWeight: 600,
        fontSize: '16px',
        color: '#212529',
    },
    tablebutton: {
        backgroundColor: '#007bff',
        color: '#ffff',
        textTransform: 'capitalize',
        borderRadius: 4,
        border: '2px solid #007bff',
        height: 30,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    tablecell: {
        border: '1px solid #dee2e6',
        color: '#212529',
        fontWeight: 600,
        fontSize: '14px',
        textAlign: 'center',
        padding: '1px',
        paddingLeft: "10px",
        paddingRight: "10px",
        whiteSpace: "nowrap"
    },
    tablecellfooter: {
        border: '1px solid #dee2e6',
        color: '#212529',
        fontWeight: 600,
        fontSize: '14px',
        textAlign: 'right',
        padding: '1px',
        paddingLeft: "10px",
        paddingRight: "10px",
    },

};


const Additemstyle = {
    color: '#212529 !important',
    textTransform: 'capitalize !important',
    borderRadius: '4px !important',
    border: '1px dashed #aecce4 !important',
    height: '30px !important',
    display: 'inline-flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    backgroundColor: '#e7f0f7 !important',
    width: '100% !important',
};
 